var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "notice-com-container",
      staticStyle: { height: "100%", position: "relative" },
    },
    [
      _vm.doShowElectronicScrollInner
        ? _c("electronic-scroll", { attrs: { content: _vm.demoContent } })
        : _vm._e(),
      _c("dialog-wakeUp", {
        attrs: { content: _vm.demoContent, dialogVisible: _vm.showDialogInner },
      }),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            top: _vm.dialogTopMargin,
            title: "通知類別維護",
            visible: _vm.dialogNoticeTypeVisible,
            width: "50%",
          },
          on: {
            closed: _vm.saveAllNoticeType,
            opened: _vm.getAgencyNoticeType,
            "update:visible": function ($event) {
              _vm.dialogNoticeTypeVisible = $event
            },
          },
        },
        [
          _c("el-alert", {
            attrs: {
              title: "通知類別維護描述不得超過200字。",
              closable: false,
              type: "warning",
            },
          }),
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                [
                  _c("el-button", {
                    staticStyle: { cursor: "pointer" },
                    attrs: {
                      loading: _vm.listLoading,
                      type: "success",
                      icon: "el-icon-refresh-left",
                      circle: "",
                    },
                    on: { click: _vm.getAgencyNoticeType },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", {
                    attrs: {
                      type: "primary",
                      icon: "el-icon-circle-plus-outline",
                      circle: "",
                    },
                    on: { click: _vm.addNoticeType },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  attrs: {
                    size: "mini",
                    data: _vm.noticeTypeOpitons,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                    height: "500px",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", label: "項次", width: "60" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.$index + 1))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "通知類別描述",
                      width: "300",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: {
                                disabled:
                                  _vm.currentNoticeTypeIndex != scope.$index,
                              },
                              model: {
                                value: scope.row.val,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "val", $$v)
                                },
                                expression: "scope.row.val",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "編輯", width: "140" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type:
                                    _vm.currentNoticeTypeIndex != scope.$index
                                      ? "success"
                                      : "primary",
                                  icon:
                                    _vm.currentNoticeTypeIndex != scope.$index
                                      ? "el-icon-edit-outline"
                                      : "el-icon-check",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.currentNoticeTypeIndex != scope.$index
                                      ? _vm.editNoticeType(
                                          scope.row,
                                          scope.$index
                                        )
                                      : _vm.saveNoticeType(
                                          scope.row,
                                          scope.$index,
                                          true
                                        )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.currentNoticeTypeIndex != scope.$index
                                      ? "編輯"
                                      : "儲存"
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "刪除", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "danger",
                                  icon: "el-icon-delete",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteNoticeType(
                                      scope.row,
                                      scope.$index
                                    )
                                  },
                                },
                              },
                              [_vm._v("刪除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            "append-to-body": "",
            top: _vm.dialogTopMargin,
            title:
              _vm.funcName +
              " 維護 " +
              (_vm.agencyMode ? "旅行社通知" : "成員通知"),
            visible: _vm.dialogNoticeVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogNoticeVisible = $event
            },
            closed: function ($event) {
              _vm.commonShowEdit = true
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c("el-alert", {
                attrs: {
                  title:
                    "預設日期為兩日，系統定期清除【通知建立日期】30日前的通知。故只允許選擇30日內的日期區間。",
                  closable: false,
                  type: "warning",
                },
              }),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": _vm.formLabelWidth },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.funcName + "建立日期" } },
                    [
                      _vm.form.buildDate
                        ? _c("el-tag", { attrs: { size: "mini" } }, [
                            _vm._v(_vm._s(_vm.form.buildDate)),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.agencyMode
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.funcName + "旅行社",
                            prop: "agencyCode",
                            rules: [
                              {
                                message: "請選擇旅行社",
                                trigger: "change",
                                required: _vm.agencyMode,
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                multiple: "",
                                placeholder: "請選擇旅行社",
                                "value-key": "key",
                              },
                              model: {
                                value: _vm.form.agencyCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "agencyCode", $$v)
                                },
                                expression: "form.agencyCode",
                              },
                            },
                            _vm._l(_vm.agencyOptions, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.val, value: item.key },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.funcName + "日期",
                        prop: "applyDates",
                        rules: [
                          {
                            required: true,
                            message: "請選擇通知日期",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "picker-options": _vm.pickerOptions,
                          type: "datetimerange",
                          format: "yyyy-MM-dd HH:mm",
                          "value-format": "yyyy-MM-dd HH:mm",
                          "range-separator": "至",
                          "start-placeholder": "開始日期",
                          "end-placeholder": "結束日期",
                          "default-time": ["00:00:00"],
                        },
                        model: {
                          value: _vm.form.applyDates,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "applyDates", $$v)
                          },
                          expression: "form.applyDates",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.funcName + "類別",
                        prop: "noticeType",
                        rules: [
                          {
                            required: true,
                            message: "請選擇類別",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { filterable: "", placeholder: "請選擇類別" },
                          on: { change: _vm.getNoticyCommons },
                          model: {
                            value: _vm.form.noticeType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "noticeType", $$v)
                            },
                            expression: "form.noticeType",
                          },
                        },
                        _vm._l(_vm.noticeTypeOpitons, function (item) {
                          return _c("el-option", {
                            key: item.key,
                            attrs: { label: item.val, value: item.key },
                          })
                        }),
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "5px" },
                          attrs: { type: "info", size: "mini" },
                          on: { click: _vm.showNoticeType },
                        },
                        [_vm._v("維護")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.funcName + "型式",
                        prop: "noticeStyle",
                        rules: [
                          {
                            required: true,
                            message: "請選擇型式",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { filterable: "", placeholder: "請選擇型式" },
                          model: {
                            value: _vm.form.noticeStyle,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "noticeStyle", $$v)
                            },
                            expression: "form.noticeStyle",
                          },
                        },
                        _vm._l(_vm.noticeStyleOptions, function (item) {
                          return _c("el-option", {
                            key: item.key,
                            attrs: { label: item.val, value: item.key },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.agencyMode,
                          expression: "!agencyMode",
                        },
                      ],
                      attrs: {
                        label: _vm.funcName + "人員",
                        prop: "members",
                        rules: [
                          {
                            required: _vm.agencyMode ? false : true,
                            message: "請選擇通知人員",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "80%" },
                          attrs: {
                            disabled: _vm.form.checkedAllMembers,
                            multiple: "",
                            filterable: "",
                            placeholder: "請選擇型式",
                          },
                          model: {
                            value: _vm.form.members,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "members", $$v)
                            },
                            expression: "form.members",
                          },
                        },
                        _vm._l(_vm.roleList, function (item) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: { label: item.name, value: item.code },
                          })
                        }),
                        1
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { "margin-left": "10px" },
                          on: { change: _vm.triggerSelectedMembers },
                          model: {
                            value: _vm.form.checkedAllMembers,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "checkedAllMembers", $$v)
                            },
                            expression: "form.checkedAllMembers",
                          },
                        },
                        [_vm._v("全選")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.funcName + "常用句" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", icon: "el-icon-star-off" },
                          on: {
                            click: function ($event) {
                              return _vm.getCommon(true)
                            },
                          },
                        },
                        [_vm._v("常用句選擇")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.funcName + "內容",
                        prop: "content",
                        rules: [
                          {
                            required: true,
                            message: "請輸入通知訊息內容",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 10,
                          placeholder: "請輸入通知訊息內容",
                        },
                        model: {
                          value: _vm.form.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "content", $$v)
                          },
                          expression: "form.content",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveData } },
                [_vm._v("確 定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogNoticeVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            "append-to-body": "",
            top: _vm.dialogTopMargin,
            title:
              _vm.funcName +
              " 維護 " +
              (_vm.agencyMode ? "旅行社通知" : "成員通知"),
            visible: _vm.dialogVisible,
            width: "80%",
          },
          on: {
            opened: function ($event) {
              return _vm.refreshNoticeList()
            },
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: function ($event) {
              _vm.commonShowEdit = true
            },
          },
        },
        [
          _c(
            "el-tabs",
            {
              attrs: { type: "border-card" },
              model: {
                value: _vm.editableTabsValue,
                callback: function ($$v) {
                  _vm.editableTabsValue = $$v
                },
                expression: "editableTabsValue",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "通知列表", name: "noticeList" } },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-form",
                        { attrs: { inline: true } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  attrs: {
                                    loading: _vm.listLoading,
                                    type: "success",
                                    icon: "el-icon-plus",
                                  },
                                  on: { click: _vm.addNotice },
                                },
                                [_vm._v("新增")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c("el-button", {
                                staticStyle: { cursor: "pointer" },
                                attrs: {
                                  loading: _vm.listLoading,
                                  type: "success",
                                  icon: "el-icon-refresh-left",
                                  circle: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.refreshNoticeList()
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.listLoading,
                              expression: "listLoading",
                            },
                          ],
                          attrs: {
                            size: "mini",
                            data: _vm.noticeList,
                            border: "",
                            fit: "",
                            "highlight-current-row": "",
                            height: "500px",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "項次",
                              width: "60",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.$index + 1)),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "通知ID",
                              width: "60",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-tag", [
                                      _vm._v(_vm._s(scope.row.id)),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "通知類別",
                              width: "150",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm._f("notifyTypeStyleFilter")(
                                            scope.row.noticeType
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.notifyTypeDescFilter(
                                              scope.row.noticeType
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "通知型式",
                              width: "100",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm._f("notifyTypeStyleFilter")(
                                            scope.row.noticeStyle
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("notifyStyleDescFilter")(
                                              scope.row.noticeStyle
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              label: "通知內容",
                              width: "360",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("notifyContentFilter")(
                                            scope.row.content
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              label: "通知對象",
                              width: "180",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.notifyMembersFilter(scope.row)
                                        ),
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "通知模式",
                              width: "100",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: scope.row.agencyMode
                                            ? "info"
                                            : "success",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.agencyMode
                                              ? "旅行社通知"
                                              : "成員通知"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "編輯",
                              width: "140",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-edit-outline",
                                          size: "mini",
                                          type: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editNotice(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("編輯")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          !_vm.commonShowEdit
                            ? _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: "選擇",
                                  width: "100",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "warning",
                                                icon: "el-icon-check",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.selectedCommon(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("選擇")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3015592660
                                ),
                              })
                            : _vm._e(),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "刪除",
                              width: "100",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "danger",
                                          icon: "el-icon-delete",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteAgencyNotice(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("刪除")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("pagination", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.noticeTotal > 0,
                        expression: "noticeTotal > 0",
                      },
                    ],
                    staticStyle: { "padding-top": "0" },
                    attrs: {
                      layout: "prev, pager, next",
                      total: _vm.noticeTotal,
                      page: _vm.listNoticeQuery.page,
                      limit: _vm.listNoticeQuery.limit,
                    },
                    on: {
                      "update:page": function ($event) {
                        return _vm.$set(_vm.listNoticeQuery, "page", $event)
                      },
                      "update:limit": function ($event) {
                        return _vm.$set(_vm.listNoticeQuery, "limit", $event)
                      },
                      pagination: function ($event) {
                        return _vm.getAgencyNotice(false)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogCommonLoading,
              expression: "dialogCommonLoading",
            },
          ],
          attrs: {
            "append-to-body": "",
            top: _vm.dialogTopMargin,
            title: _vm.funcName + "常用句維護",
            visible: _vm.commonDialogVisible,
            width: "60%",
          },
          on: {
            closed: _vm.saveAllCommon,
            "update:visible": function ($event) {
              _vm.commonDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("el-alert", {
                attrs: {
                  title: "常用句不得超過500字。",
                  closable: false,
                  type: "warning",
                },
              }),
              _c(
                "el-form",
                { attrs: { inline: true } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-button", {
                        staticStyle: { cursor: "pointer" },
                        attrs: {
                          loading: _vm.listLoading,
                          type: "success",
                          icon: "el-icon-refresh-left",
                          circle: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.getCommon(false)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-button", {
                        attrs: {
                          type: "primary",
                          icon: "el-icon-circle-plus-outline",
                          circle: "",
                        },
                        on: { click: _vm.addCommon },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  attrs: {
                    size: "mini",
                    data: _vm.commonList,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                    height: "500px",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", label: "項次", width: "60" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.$index + 1))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "通知類別", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.noticeTypeOpitons &&
                            _vm.noticeTypeOpitons.length > 0
                              ? _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled:
                                        _vm.currentCommonIndex != scope.$index,
                                      filterable: "",
                                      placeholder: "請選擇類別",
                                    },
                                    model: {
                                      value: scope.row.commonType,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "commonType", $$v)
                                      },
                                      expression: "scope.row.commonType",
                                    },
                                  },
                                  _vm._l(
                                    _vm.noticeTypeOpitons,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          label: item.val,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "常用句", width: "250" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: {
                                maxlength: "500",
                                type: "textarea",
                                rows: 2,
                                disabled:
                                  _vm.currentCommonIndex != scope.$index,
                              },
                              model: {
                                value: scope.row.common,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "common", $$v)
                                },
                                expression: "scope.row.common",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "建立日期", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.buildDate))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "建立者", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.buildUserName)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "編輯", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type:
                                    _vm.currentCommonIndex != scope.$index
                                      ? "success"
                                      : "primary",
                                  icon:
                                    _vm.currentCommonIndex != scope.$index
                                      ? "el-icon-edit-outline"
                                      : "el-icon-check",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.currentCommonIndex != scope.$index
                                      ? _vm.editCommon(scope.row, scope.$index)
                                      : _vm.saveCommon(
                                          scope.row,
                                          scope.$index,
                                          true
                                        )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.currentCommonIndex != scope.$index
                                      ? "編輯"
                                      : "儲存"
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  !_vm.commonShowEdit
                    ? _c("el-table-column", {
                        attrs: { align: "center", label: "選擇", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: "warning",
                                        icon: "el-icon-check",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectedCommon(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("選擇")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3015592660
                        ),
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "刪除", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "danger",
                                  icon: "el-icon-delete",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteAgencyNoticeCommon(
                                      scope.row,
                                      scope.$index
                                    )
                                  },
                                },
                              },
                              [_vm._v("刪除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogSysNoticeLoading,
              expression: "dialogSysNoticeLoading",
            },
          ],
          attrs: {
            "append-to-body": "",
            top: _vm.dialogTopMargin,
            title: "系統通知維護",
            visible: _vm.sysNoticeDialogVisible,
            width: "80%",
          },
          on: {
            closed: function ($event) {
              _vm.sysNoticeDialogVisible = false
            },
            "update:visible": function ($event) {
              _vm.sysNoticeDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("el-alert", {
                attrs: {
                  title: "通知內容不得超過500字。",
                  closable: false,
                  type: "warning",
                },
              }),
              _c(
                "el-form",
                { attrs: { inline: true } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-button", {
                        staticStyle: { cursor: "pointer" },
                        attrs: {
                          loading: _vm.listLoading,
                          type: "success",
                          icon: "el-icon-refresh-left",
                          circle: "",
                        },
                        on: { click: _vm.getSysNotice },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-button", {
                        attrs: {
                          type: "primary",
                          icon: "el-icon-circle-plus-outline",
                          circle: "",
                        },
                        on: { click: _vm.addSysNotice },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  attrs: {
                    size: "mini",
                    data: _vm.sysNoticeList,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                    height: "500px",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", label: "項次", width: "60" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.$index + 1))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "內容", width: "250" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: {
                                maxlength: "500",
                                type: "textarea",
                                rows: 3,
                                disabled:
                                  _vm.currentSysNoticeIndex != scope.$index,
                              },
                              model: {
                                value: scope.row.content,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "content", $$v)
                                },
                                expression: "scope.row.content",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "建立日期", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.buildDate))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "起始日期", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.applyDates[0])),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "結束日期", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.applyDates[1])),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "建立者", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.buildUser))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "編輯", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  icon: "el-icon-edit-outline",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.editSysNotice(scope.row)
                                  },
                                },
                              },
                              [_vm._v("編輯")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "刪除", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "danger",
                                  icon: "el-icon-delete",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteSysNotice(scope.row)
                                  },
                                },
                              },
                              [_vm._v("刪除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.sysNoticeTotal > 0,
                    expression: "sysNoticeTotal > 0",
                  },
                ],
                staticStyle: { "padding-top": "0" },
                attrs: {
                  layout: "prev, pager, next",
                  total: _vm.sysNoticeTotal,
                  page: _vm.listSysNoticeQuery.page,
                  limit: _vm.listSysNoticeQuery.limit,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.listSysNoticeQuery, "page", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.listSysNoticeQuery, "limit", $event)
                  },
                  pagination: _vm.getSysNotice,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            "append-to-body": "",
            top: _vm.dialogTopMargin,
            title: "系統維護通知",
            visible: _vm.dialogSysNoticeFormVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogSysNoticeFormVisible = $event
            },
            closed: function ($event) {
              _vm.dialogSysNoticeFormVisible = false
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c("el-alert", {
                attrs: {
                  title:
                    "預設日期為兩日，系統定期清除【通知建立日期】30日前的通知。故只允許選擇30日內的日期區間。",
                  closable: false,
                  type: "warning",
                },
              }),
              _c(
                "el-form",
                {
                  ref: "sysNoticeForm",
                  attrs: { model: _vm.form, "label-width": _vm.formLabelWidth },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "建立日期" } },
                    [
                      _vm.form.buildDate
                        ? _c("el-tag", { attrs: { size: "mini" } }, [
                            _vm._v(_vm._s(_vm.form.buildDate)),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "日期",
                        prop: "applyDates",
                        rules: [
                          {
                            required: true,
                            message: "請選擇通知日期",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "picker-options": _vm.pickerOptions,
                          type: "datetimerange",
                          format: "yyyy-MM-dd HH:mm",
                          "value-format": "yyyy-MM-dd HH:mm",
                          "range-separator": "至",
                          "start-placeholder": "開始日期",
                          "end-placeholder": "結束日期",
                          "default-time": ["00:00:00"],
                        },
                        model: {
                          value: _vm.form.applyDates,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "applyDates", $$v)
                          },
                          expression: "form.applyDates",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "內容",
                        prop: "content",
                        rules: [
                          {
                            required: true,
                            message: "請輸入通知訊息內容",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 10,
                          placeholder: "請輸入通知訊息內容",
                        },
                        model: {
                          value: _vm.form.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "content", $$v)
                          },
                          expression: "form.content",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveSysNotice },
                },
                [_vm._v("確 定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogSysNoticeFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { padding: "20px", "padding-bottom": "0" } },
        [
          _c(
            "el-form",
            {
              attrs: { inline: true },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "旅行社名稱查詢" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "輸入旅行社名稱" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.getList($event)
                      },
                    },
                    model: {
                      value: _vm.listQuery.qry,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "qry", $$v)
                      },
                      expression: "listQuery.qry",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.getList },
                    },
                    [_vm._v("查詢")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _vm.multipleSelection.length > 0
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "danger", icon: "el-icon-bell" },
                          on: {
                            click: function ($event) {
                              return _vm.addNoticeHandle(true)
                            },
                          },
                        },
                        [_vm._v("旅行社通知")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "info", icon: "el-icon-info" },
                      on: { click: _vm.agencyNoticeHistory },
                    },
                    [_vm._v("旅行社通知維護")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", icon: "el-icon-star-off" },
                      on: {
                        click: function ($event) {
                          return _vm.getCommon(false)
                        },
                      },
                    },
                    [_vm._v("常用句維護")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", icon: "el-icon-star-off" },
                      on: { click: _vm.getSysNotice },
                    },
                    [_vm._v("系統通知維護")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", {
                    staticStyle: { cursor: "pointer" },
                    attrs: {
                      loading: _vm.listLoading,
                      type: "success",
                      icon: "el-icon-refresh-left",
                      circle: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.refresh()
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: {
                    border: "1px solid #ccc",
                    padding: "5px",
                    "border-radius": "10px",
                  },
                  attrs: { label: "通知樣式預覽" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.showDemo },
                      model: {
                        value: _vm.demo,
                        callback: function ($$v) {
                          _vm.demo = $$v
                        },
                        expression: "demo",
                      },
                    },
                    _vm._l(_vm.noticeStyleOptions, function (item) {
                      return _c(
                        "el-radio",
                        { key: item.key, attrs: { label: item.key } },
                        [_vm._v(_vm._s(item.val))]
                      )
                    }),
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "15px" },
                      attrs: { size: "mini", type: "danger" },
                      on: { click: _vm.closeDemo },
                    },
                    [_vm._v("關閉預覽")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "旅行社代碼", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.agencyCode))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "旅行社名稱", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.agencyName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "統編", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.vatNumber))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "成員通知", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "warning", icon: "el-icon-bell" },
                            on: {
                              click: function ($event) {
                                return _vm.membersNotice(scope.row)
                              },
                            },
                          },
                          [_vm._v("成員通知")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "padding-top": "0" },
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }